module.exports = __webpack_public_path__ + "img/percentege.79d62e9e.svg";